import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, trackCheckout } from "../utils/checkout";
interface CTAButtonProps {
  label: string;
  sub?: string;
  id?: string;
  tone?: "dark" | "light";
}
export function CTAButton({
  label,
  sub,
  id,
  tone = "light"
}: CTAButtonProps) {
  return <div className="mx-auto w-full max-w-xl text-center" data-id="element-104" data-mp="2fyjwp2l0dcci">
      <a id={id} href={CHECKOUT_URL} onClick={trackCheckout} className="flex min-h-[64px] w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-4 font-display text-[17px] font-extrabold uppercase leading-tight tracking-wide text-navy-950 shadow-[0_5px_0_0_#C99A00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-[0_2px_0_0_#C99A00] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent/60 md:text-xl" data-id="element-105" data-mp="2tzctxv2p2ljb">
        <span data-id="element-106" data-mp="38ptulc7i97f5">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-107" data-mp="38mfqnzj70q5l" />
      </a>
      {sub && <p className={`mt-3 text-[13px] font-medium ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-108" data-mp="19b98u4a1eoq3">
          {sub}
        </p>}
    </div>;
}